package org.example.zone360.pages.dashboard.dashboardAssistantAI

import org.example.zone360.utils.adminBotStreamRequest
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateListOf
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.runtime.setValue
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.css.TextAlign
import com.varabyte.kobweb.compose.css.TransitionProperty
import com.varabyte.kobweb.compose.css.WhiteSpace
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundColor
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderBottom
import com.varabyte.kobweb.compose.ui.modifiers.borderLeft
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.borderTop
import com.varabyte.kobweb.compose.ui.modifiers.bottom
import com.varabyte.kobweb.compose.ui.modifiers.boxShadow
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxHeight
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxSize
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.flexWrap
import com.varabyte.kobweb.compose.ui.modifiers.gap
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.id
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.right
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.transform
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.fa.FaDownload
import com.varabyte.kobweb.silk.components.icons.fa.FaPlus
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import org.example.zone360.utils.generateChatbotReport
import kotlinx.browser.document
import kotlinx.coroutines.CancellationException
import kotlinx.coroutines.launch
import kotlinx.serialization.encodeToString
import kotlinx.serialization.json.Json
import org.example.zone360.components.CommonButton
import org.example.zone360.components.CustomSpacer
import org.example.zone360.components.CyclingThinkingIndicator
import org.example.zone360.components.DownloadPdfRequest
import org.example.zone360.components.ProgressIndicator
import org.example.zone360.components.showToast
import org.example.zone360.componentss.FieldTitleTextNormalSimple
import org.example.zone360.models.AdminBotRequest
import org.example.zone360.models.ChatBotMessage
import org.example.zone360.models.ConversationHistory
import org.example.zone360.models.GetClubPerformanceData
import org.example.zone360.models.GetPlayerData
import org.example.zone360.models.GetSessionsData
import org.example.zone360.models.GetSingleCoachData
import org.example.zone360.pages.coachDetails.coachAssistAi.AssistAIConstants.quickDashboardActionQuestions
import org.example.zone360.pages.coachDetails.coachAssistAi.isPaymentActive
import org.example.zone360.pages.players_Details.assistAI.ExpandableContent
import org.example.zone360.theme.Palette
import org.example.zone360.theme.SitePalette
import org.example.zone360.utils.AppGlobal
import org.example.zone360.utils.Config
import org.example.zone360.utils.Constants
import org.example.zone360.utils.MarkdownRenderer
import org.example.zone360.utils.Res
import org.example.zone360.utils.SelectedData
import org.example.zone360.utils.SelectedLanguage
import org.example.zone360.utils.Strings
import org.example.zone360.utils.ToastID
import org.jetbrains.compose.web.attributes.placeholder
import org.jetbrains.compose.web.css.FlexWrap
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.Position
import org.jetbrains.compose.web.css.deg
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.outline
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.TextArea
import org.w3c.dom.HTMLElement
import org.w3c.dom.HTMLInputElement
import org.w3c.dom.HTMLTextAreaElement
import org.example.zone360.utils.updateUserData
import kotlin.collections.plus

@Composable
fun ResponsiveDashboardChatbot(
    onDismiss: () -> Unit = {},
    toastMessage: (String) -> Unit = {},
    breakpoint: Breakpoint,
    sitePalette: SitePalette,
    userId: String,
    selectedSessionType: SelectedData,
    selectedLanguage: SelectedLanguage,
    getCoachInfo: GetSingleCoachData,
    showOverlay: Boolean,
    onShowOverlayChange: (Boolean) -> Unit,
    sessionList: List<GetSessionsData>,
    playersList: List<GetPlayerData>,
    subscriptionPopup: (Boolean) -> Unit,
    performanceResponse: GetClubPerformanceData,
) {
    val scope = rememberCoroutineScope()
    var userInput by remember { mutableStateOf("") }
    var chatBotResponse by remember { mutableStateOf("") }
    var isLoading by remember { mutableStateOf(false) }
    var isButtonLoading by remember { mutableStateOf(false) }
    val getChatBotMessage = remember { mutableStateListOf<ChatBotMessage>() }
    var questionLimitReached by remember { mutableStateOf(false) }
    val botQuestionsAlreadyAsked = getCoachInfo.botQuestionAsked
    var isQuickActionLoading by remember { mutableStateOf(false) }
    var questionCount by remember { mutableStateOf(botQuestionsAlreadyAsked) }

    fun updateQuestionCount(newCount: Int) {
        scope.launch {
            try {
                val updatedCoachInfo = getCoachInfo.copy(botQuestionAsked = newCount)
                val json = Json.encodeToString(updatedCoachInfo)
                updateUserData(json)
            } catch (e: Exception) {
                console.error("Failed to update botQuestionAsked count: $e")
            }
        }
    }

    val apiLanguageType = when (selectedLanguage) {
        SelectedLanguage.English -> "en"
        SelectedLanguage.Italian -> "it"
    }
    val apiSessionType = when (selectedSessionType) {
        SelectedData.Matches -> Strings.MATCH
        SelectedData.Training -> Strings.TRAINING
    }


//    var expandedCategory by remember { mutableStateOf<String?>(null) }
    var expandedCategory by remember { mutableStateOf(setOf<String>()) }
    fun isPaid(status: String): Boolean = status in setOf(Strings.PAID, Strings.SUCCEEDED)

    // Logic start
    val coachHasReachedLimit = getCoachInfo.botQuestionAsked >= Config.allowedQuestions

    val isIndependentCoach = getCoachInfo.organization == Strings.INDEPENDENT
    val isCoachPaid = isPaid(getCoachInfo.payment.checkout.status)
    val isCoachUnexpired = isPaymentActive(getCoachInfo.payment.checkout.expiredOn)

// Club scenarios → choose payment source based on role
    val (isClubPaid, isClubUnexpired) = when (AppGlobal.userData.role) {
        Strings.ADMIN -> {
            isPaid(AppGlobal.userData.payment.checkout.status) to
                    isPaymentActive(AppGlobal.userData.payment.checkout.expiredOn)
        }

        else -> {
            isPaid(AppGlobal.userData.clubPayment.status) to
                    isPaymentActive(AppGlobal.userData.clubPayment.expiredOn)
        }
    }

    val notAllowedCondition = when {
        isIndependentCoach -> (!isCoachPaid || !isCoachUnexpired) && coachHasReachedLimit
        else -> (!isClubPaid || !isClubUnexpired) && coachHasReachedLimit
    }


    val overLayOptions = showOverlay || notAllowedCondition


    scope.launch {
        userInput = (document.getElementById(Res.Id.messageAiInput) as HTMLTextAreaElement).value
    }

    if (getCoachInfo.payment.checkout.status != Strings.PAID) {
        LaunchedEffect(questionCount) {
            if (questionCount > Config.allowedQuestions) {
                questionLimitReached = true
                subscriptionPopup(true)
                expandedCategory = emptySet()
                onShowOverlayChange(true)
                (document.getElementById(Res.Id.messageAiInput) as HTMLInputElement).value = ""
            }
        }
    }

    LaunchedEffect(
        getChatBotMessage.lastOrNull()?.message?.length,
        getChatBotMessage.lastOrNull()?.status
    ) {
        kotlinx.coroutines.delay(50)

        val container =
            document.getElementById(Res.Id.scrollContainerId) as? HTMLElement

        container?.scrollTop =
            container?.scrollHeight?.toDouble() ?: 0.0
    }

//    LaunchedEffect(getChatBotMessage.size) {
//        val container = document.getElementById(Res.Id.scrollContainerId) as? HTMLElement
//        val lastMessage = getChatBotMessage.lastOrNull()
//
//        // Only scroll to bottom if the last message was sent by the user
//        if (lastMessage?.isUserMessage == true) {
//            if (container != null) {
//                container.scrollTop = container.scrollHeight.toDouble()
//            }
//        }
//    }

    fun handleUserMessage(
        message: String,
        isFromQuickAction: Boolean = false,
        forceReport: Boolean = false
    ) {
        if (message.isBlank() || overLayOptions || isLoading) return

        if ((isFromQuickAction && isQuickActionLoading) ||
            (!isFromQuickAction && isButtonLoading)
        ) return

        scope.launch {

            if (isFromQuickAction) {
                isQuickActionLoading = true
            } else {
                isButtonLoading = true
            }

            if (!isFromQuickAction) {
                val inputField =
                    document.getElementById(Res.Id.messageAiInput) as? HTMLTextAreaElement
                inputField?.value = ""
                userInput = ""
            }

            try {
                // User message
                getChatBotMessage.add(
                    ChatBotMessage(
                        message = message,
                        isUserMessage = true
                    )
                )

                val history = getChatBotMessage
                    .dropLast(1)
                    .takeLast(Config.ALLOWED_CONVERSATION_HISTORY)
                    .map {
                        ConversationHistory(
                            role = if (it.isUserMessage) "user" else "assistant",
                            content = it.message
                        )
                    }

                val payload = AdminBotRequest(
                    query = message,
                    role = AppGlobal.userData.role,
                    userId = AppGlobal.userData.uid,
                    organization = AppGlobal.userData.organization,
                    seasonID = AppGlobal.selectedSeasonId,
                    generatePdf = forceReport,
                    conversationHistory = history.ifEmpty { null }
                )

                // Empty assistant message
                getChatBotMessage.add(
                    ChatBotMessage(
                        isUserMessage = false,
                        message = "",
                        status = "Thinking",
                        isThinking = true
                    )
                )

                val botIndex = getChatBotMessage.lastIndex
                adminBotStreamRequest(
                    payload = payload,
                    onEvent = { event ->
                        val current = getChatBotMessage[botIndex]
                        when (event.type) {
                            "thinking" -> {
                                // Ignore if we've already shown a status
                                if (current.status.isBlank() && current.message.isBlank()) {
                                    getChatBotMessage[botIndex] = current.copy(
                                        status = "Thinking",
                                        isThinking = true
                                    )
                                }
                            }

                            "tool" -> {
                                val toolStatus = when (event.name) {
                                    "list_coaches" ->
                                        "Searching coaches"

                                    "get_club_keywords" ->
                                        "Loading club keywords"

                                    "get_coach_keywords" ->
                                        "Analyzing coach sessions"

                                    else ->
                                        "Using ${event.name}"
                                }
                                getChatBotMessage[botIndex] = current.copy(
                                    status = toolStatus,
                                    isThinking = true
                                )
                            }

                            "token" -> {
                                val latest = getChatBotMessage[botIndex]
                                getChatBotMessage[botIndex] = latest.copy(
                                    status = "",
                                    isThinking = false,
                                    isStreaming = true,
                                    message = latest.message + event.content.orEmpty()
                                )
                            }

                            "done" -> {
                                val latest = getChatBotMessage[botIndex]
                                getChatBotMessage[botIndex] = latest.copy(
                                    status = "",
                                    isThinking = false,
                                    isStreaming = false,
                                    pdfPayload = event.pdfPayload,
                                    pdfType = event.pdfType
                                )
                            }
                        }
                    },

                    onError = {
                        val current = getChatBotMessage[botIndex]
                        getChatBotMessage[botIndex] = current.copy(
                            status = "",
                            isThinking = false,
                            isStreaming = false,
                            message = "Something went wrong"
                        )
                        if (isFromQuickAction) {
                            isQuickActionLoading = false
                        } else {
                            isButtonLoading = false
                        }
                    }
                )

            } catch (ce: CancellationException) {
                throw ce
            } catch (e: Throwable) {
                getChatBotMessage.add(
                    ChatBotMessage(
                        message = "Something went wrong",
                        isUserMessage = false
                    )
                )

            } finally {
                if (isFromQuickAction) {
                    isQuickActionLoading = false
                } else {
                    isButtonLoading = false
                }
            }
        }
    }
//    fun handleUserMessage(
//        message: String,
//        isFromQuickAction: Boolean = false,
//        forceReport: Boolean = false
//    ) {
//        if (message.isBlank() || overLayOptions || isLoading) return
//
//        // Prevent double submission
//        if ((isFromQuickAction && isQuickActionLoading) || (!isFromQuickAction && isButtonLoading)) return
//
//        scope.launch {
//            // Set appropriate loading state based on source
//            if (isFromQuickAction) {
//                isQuickActionLoading = true
//            } else {
//                isButtonLoading = true
//            }
//
//            // Clear the text area only if it's from manual input
//            if (!isFromQuickAction) {
//                val inputField =
//                    document.getElementById(Res.Id.messageAiInput) as? HTMLTextAreaElement
//                inputField?.value = ""
//                userInput = ""
//            }
//
//            try {
//                // Store user message in chat list
//                getChatBotMessage.add(ChatBotMessage(message = message, isUserMessage = true))
//                val history = getChatBotMessage
//                    .dropLast(1) // exclude the user current message we just added
//                    .takeLast(Config.ALLOWED_CONVERSATION_HISTORY)
//                    .map {
//                        ConversationHistory(
//                            role = if (it.isUserMessage) "user" else "assistant",
//                            content = it.message
//                        )
//                    }
//                val payload = AdminBotRequest(
//                    query = message,
//                    role = AppGlobal.userData.role,
//                    userId = AppGlobal.userData.uid,
//                    organization = AppGlobal.userData.organization,
//                    seasonID = AppGlobal.selectedSeasonId,
//                    conversationHistory = history.ifEmpty { null },
//                    generatePdf = forceReport
//                )
//                getChatBotMessage.add(
//                    ChatBotMessage(
//                        message = "",
//                        isUserMessage = false
//                    )
//                )
//
//                val botIndex = getChatBotMessage.lastIndex
//                adminBotStreamRequest(
//                    payload = payload,
//                    onEvent = { event ->
//
//                        when (event.type) {
//                            "thinking" -> {
//
//                                val current = getChatBotMessage[botIndex]
//                                getChatBotMessage[botIndex] = current.copy(
//                                    message = current.message + "\nThinking...\n"
//                                )
//                            }
//
//                            "tool" -> {
//
//                                val current = getChatBotMessage[botIndex]
//
//                                getChatBotMessage[botIndex] = current.copy(
//                                    message = current.message + "\nUsing ${event.name}...\n"
//                                )
//                            }
//
//                            "token" -> {
//
//                                val current = getChatBotMessage[botIndex]
//                                getChatBotMessage[botIndex] = current.copy(
//                                    message = current.message + event.content.orEmpty()
//                                )
//                            }
//
//                            "done" -> {
//                                val current = getChatBotMessage[botIndex]
//                                getChatBotMessage[botIndex] = current.copy(
//                                    message = event.summary?.let {
//                                        cleanMarkdownAndDetect(it)
//                                    } ?: current.message,
//                                    pdfPayload = event.pdfPayload,
//                                    pdfType = event.pdfType
//                                )
//                            }
//                        }
//                    },
//                    onError = {
//                        getChatBotMessage[botIndex] =
//                            getChatBotMessage[botIndex].copy(
//                                message = "Something went wrong"
//                            )
//                        if (isFromQuickAction) {
//                            isQuickActionLoading = false
//                        } else {
//                            isButtonLoading = false
//                        }
//                    }
//                )
////                val response = adminBotRequest(payload)
////                val cleanedText = response.summary?.let { cleanMarkdownAndDetect(it) }
////                getChatBotMessage.add(
////                    ChatBotMessage(
////                        message = cleanedText.orEmpty(),
////                        pdfPayload = response.pdfPayload,
////                        pdfType = response.pdfType
////                    )
////                )
//
//            } catch (ce: CancellationException) {
//                throw ce
//            } catch (e: Throwable) {
//                getChatBotMessage.add(
//                    ChatBotMessage(
//                        message = "Something went wrong",
//                        isUserMessage = false
//                    )
//                )
//            } finally {
//                // Reset appropriate loading state
//                if (isFromQuickAction) {
//                    isQuickActionLoading = false
//                } else {
//                    isButtonLoading = false
//                }
//            }
//        }
//    }


    Box(
        modifier = Modifier
            .margin(top = 20.px, bottom = 10.px)
            .fillMaxWidth()
            .backgroundColor(sitePalette.modalBackgroundColor.rgb)
            .boxShadow(
                offsetY = 1.px,
                blurRadius = 3.px,
                color = sitePalette.boxShadowColor.rgb
            )
            .borderRadius(15.px)
            .border(1.px, style = LineStyle.Solid, color = sitePalette.coachDetailsBoxBorder.rgb)

    ) {
        Box(
            modifier = Modifier.fillMaxWidth().fillMaxHeight().position(Position.Relative)
        ) {
            Column(
                modifier = Modifier.fillMaxSize()
                    .padding(topBottom = 16.px, leftRight = 24.px)
            ) {
                Row(
                    modifier = Modifier.fillMaxWidth(),
                    verticalAlignment = Alignment.CenterVertically,
                )
                {
                    // Image with light grey background
                    Box(
                        modifier = Modifier
                            .size(52.px)
                            .borderRadius(100.px)
                            .border(
                                width = 1.px,
                                color = Colors.LightGray,  // Same color as background
                                style = LineStyle.Solid
                            )
                            .backgroundColor(Colors.LightGray),  // Light grey background
                        contentAlignment = Alignment.Center
                    ) {
                        Image(
                            src = Res.Images.assistAiMatt,
                            modifier = Modifier.size(52.px).borderRadius(100.px)
                        )
                    }
                    CustomSpacer(20.px)
                    Column {
                        FieldTitleTextNormalSimple(
                            text = "AssistAI",
                            fontWeight = 600,
                            fontSize = 20.px
                        )
                        Row(verticalAlignment = Alignment.CenterVertically) {
                            Box(
                                modifier = Modifier.width(6.px).height(6.px)
                                    .borderRadius(100.percent)
                                    .backgroundColor(Palette.GreenShadeColor.rgbLight)
                            )
                            FieldTitleTextNormalSimple(
                                text = "Online",
                                fontWeight = 500,
                                fontSize = 14.px,
                                color = Palette.GreenShadeColor.rgbLight,
                                marginLeft = 5.px
                            )
                        }
                    }
                    Spacer()
//                    FaXmark(
//                        modifier = Modifier.onClick{ onDismiss()},
//                        size = IconSize.LG
//                    )
                }
                Box(
                    modifier = Modifier
                        .fillMaxWidth()
                        .height(if (breakpoint <= Breakpoint.MD) 380.px else 450.px)
                        .margin(topBottom = 15.px)
                        .position(Position.Relative)
                )
                {
                    Column(
                        modifier = Modifier.fillMaxWidth()
                            .padding(10.px)
                            .height(if (breakpoint <= Breakpoint.MD) 380.px else 450.px)
                            .id(Res.Id.scrollContainerId)
                            .overflow(Overflow.Auto)
                            .borderTop(
                                width = 1.px,
                                style = LineStyle.Solid,
                                color = sitePalette.textFieldBorderColor.rgb
                            )
                            .borderBottom(
                                width = 1.px,
                                style = LineStyle.Solid,
                                color = sitePalette.textFieldBorderColor.rgb
                            ),
                    ) {
                        // Check if the chat messages list is empty
                        if (getChatBotMessage.isEmpty() && !isLoading && !isButtonLoading) {
                            // Placeholder content when no messages
                            Box(
                                modifier = Modifier.fillMaxSize(),
                                contentAlignment = Alignment.Center
                            ) {
                                Column(
                                    horizontalAlignment = Alignment.CenterHorizontally,
                                    modifier = Modifier.padding(16.px)
                                ) {
                                    FieldTitleTextNormalSimple(
                                        text = "Chat with the bot to ask questions, or explore features with Quick Assist.",
                                        fontSize = 14.px,
                                        color = Colors.Gray,
                                        textAlign = TextAlign.Center,
                                    )
                                }
                            }
                        } else {
                            // Existing messages
                            getChatBotMessage.forEach { msg ->
                                var isDownloading by remember { mutableStateOf(false) }
                                Row(
                                    modifier = Modifier.fillMaxWidth().margin(topBottom = 10.px),
                                    horizontalArrangement = if (msg.isUserMessage) Arrangement.End else Arrangement.Start,
                                ) {
                                    if (!msg.isUserMessage) {
                                        Image(
                                            src = Res.Images.assistAiMatt,
                                            modifier = Modifier.size(30.px).borderRadius(100.px)
                                        )
                                        CustomSpacer(width = 10.px)
                                    }
                                    Column(
                                        modifier = Modifier
                                            .maxWidth(80.percent)
                                            .backgroundColor(if (msg.isUserMessage) sitePalette.lightGrey.rgb else Colors.Transparent)
                                            .borderRadius(8.px)
                                            .then(
                                                if (!msg.isUserMessage && msg.pdfPayload != null) Modifier.border(
                                                    width = 1.px,
                                                    style = LineStyle.Solid,
                                                    color = sitePalette.coachDetailsBoxBorder.rgb
                                                ) else Modifier
                                            )
                                            .padding(top = 8.px, bottom = 8.px, leftRight = 8.px)
                                    ) {
                                        if (!msg.isUserMessage && msg.pdfPayload != null) {
                                            Row(
                                                modifier = Modifier.fillMaxWidth().gap(6.px),
                                                verticalAlignment = Alignment.CenterVertically,
                                                horizontalArrangement = Arrangement.End
                                            ) {
                                                CommonButton(
                                                    loaderSize = 15.px,
                                                    isLoading = isDownloading,
                                                    width = 143.px,
                                                    height = 25.px,
                                                    icon = {
                                                        FaDownload(
                                                            modifier = Modifier.color(
                                                                sitePalette.bodyBackgroundSecondary.rgb
                                                            )
                                                        )
                                                    },
                                                    onCLick = {
                                                        scope.launch {
                                                            try {
                                                                isDownloading = true
                                                                generateChatbotReport(
                                                                    DownloadPdfRequest(pdfPayload = msg.pdfPayload)
                                                                )
                                                            } catch (ce: CancellationException) {
                                                                throw ce
                                                            } catch (e: Throwable) {
                                                                toastMessage("Something went wrong")
                                                                showToast(ToastID.ERROR)
                                                            } finally {
                                                                isDownloading = false
                                                            }
                                                        }
                                                    },
                                                    text = "Download PDF",
                                                )
                                            }
                                        }
                                        if (msg.status.isNotBlank()) {
                                            CyclingThinkingIndicator(
                                                text = msg.status
                                            )
                                            Spacer()
                                        }

                                        if (msg.message.isNotBlank()) {
                                            MarkdownRenderer(
                                                text = msg.message,
                                                isStreaming = msg.isStreaming,
                                                width = 100.percent,
                                                whiteSpace = WhiteSpace.Normal,
                                                fontSize = 16.px,
                                                fontFamily = Constants.IBM_FONT
                                            )
                                        }
//                                        MarkdownRenderer(
//                                            text = msg.message,
//                                            width = 100.percent,
//                                            whiteSpace = WhiteSpace.Normal,
//                                            fontSize = 16.px,
//                                            fontFamily = Constants.IBM_FONT
//                                        )
                                    }
                                }
                            }
                        }
                    }
                }

                Row(
                    modifier = Modifier.fillMaxWidth().gap(5.px),
                    verticalAlignment = Alignment.CenterVertically,
                ) {
                    Box(
                        modifier = Modifier
                            .size(34.px)
                            .borderRadius(10.px)
                            .backgroundColor(sitePalette.lightGrey.rgb),
                        contentAlignment = Alignment.Center
                    ) {
                        Image(
                            src = Res.Images.action,
                            modifier = Modifier.size(20.px)
                        )
                    }
                    FieldTitleTextNormalSimple(
                        text = "Quick Actions",
                        fontSize = 16.px,
                        fontWeight = 500
                    )
                }
                Row(
                    modifier = Modifier
                        .fillMaxWidth()
                        .height(138.px)
                        .margin(topBottom = 10.px).padding(right = 10.px)
                        .gap(10.px).overflow(Overflow.Auto)
                        .flexWrap(FlexWrap.Wrap)
                        .id(Res.Id.quickActionsContainer)
                )
                {
                    quickDashboardActionQuestions.forEach { (category, questions) ->
                        Column(modifier = Modifier.width(100.percent)) {
                            Box(
                                modifier = Modifier
                                    .fillMaxWidth()
                                    .backgroundColor(Colors.White)
                                    .borderRadius(12.px)

                                    // Light grey border on all sides
                                    .border(
                                        width = 1.px,
                                        style = LineStyle.Solid,
                                        color = Colors.LightGray
                                    )

                                    // Orange left accent (placed after border so it overrides left side)
                                    .borderLeft(
                                        width = 3.px,
                                        style = LineStyle.Solid,
                                        color = sitePalette.primary.rgb
                                    )

                                    .padding(12.px)
                                    .cursor(Cursor.Pointer)
                                    .id("category_$category")
                                    .onClick {
                                        val isExpanding =
                                            !expandedCategory.contains(category)

                                        expandedCategory = if (isExpanding) {
                                            expandedCategory + category
                                        } else {
                                            expandedCategory - category
                                        }
                                    }
                            )
                            {
                                Row(
                                    modifier = Modifier.fillMaxWidth(),
                                    verticalAlignment = Alignment.Top
                                ) {

                                    FieldTitleTextNormalSimple(
                                        text = category.substringBefore(" "),
                                        fontSize = 20.px
                                    )

                                    CustomSpacer(12.px)

                                    Column(
                                        modifier = Modifier.weight(1f)
                                    ) {

                                        FieldTitleTextNormalSimple(
                                            text = category.substringAfter(" "),
                                            fontSize = 14.px,
                                            fontWeight = 600
                                        )

                                        FieldTitleTextNormalSimple(
                                            text = when {
                                                category.contains("Club Terminology") ->
                                                    "Understand coaching terms and concepts"

                                                category.contains("Training Session Design") ->
                                                    "Create effective training sessions"

                                                category.contains("In Possession") ->
                                                    "Build up play strategies"

                                                category.contains("Out of Possession") ->
                                                    "Defensive shape and pressing"

                                                category.contains("Player Development") ->
                                                    "Individual growth and development plans"

                                                category.contains("Tactical Consistency") ->
                                                    "Evaluate tactical alignment"

                                                else ->
                                                    "Communication and leadership insights"
                                            },
                                            fontSize = 12.px,
                                            color = Colors.Gray
                                        )
                                    }
                                    Spacer()
                                    Box(
                                        modifier = Modifier,
                                        contentAlignment = Alignment.TopStart
                                    ) {
                                        FaPlus(
                                            modifier = Modifier
                                                .color(sitePalette.primary.rgb)
                                                .transition(
                                                    com.varabyte.kobweb.compose.css.Transition.of(
                                                        TransitionProperty.All,
                                                        300.ms
                                                    )
                                                )
                                                .transform {
                                                    rotate(
                                                        if (expandedCategory.contains(
                                                                category
                                                            )
                                                        )
                                                            45.deg
                                                        else
                                                            0.deg
                                                    )
                                                }
                                        )
                                    }
                                }
                            }
                            ExpandableContent(visible = expandedCategory.contains(category)) {
                                Row(
                                    Modifier
                                        .fillMaxWidth()
                                        .flexWrap(FlexWrap.Wrap)
                                        .margin(
                                            left = 10.px,
                                            top = 6.px,
                                            bottom = 12.px
                                        )
                                        .gap(6.px)
                                ) {
                                    questions.forEach { question ->
                                        Box(
                                            Modifier
//                                                        .fillMaxWidth()
                                                .padding(6.px)
                                                .backgroundColor(Colors.White)
                                                .borderRadius(8.px)
                                                .cursor(if (isLoading || isButtonLoading || isQuickActionLoading) Cursor.NotAllowed else Cursor.Pointer)
                                                .border(
                                                    1.px,
                                                    LineStyle.Solid,
                                                    sitePalette.primary.rgb
                                                )
                                                .onClick {
                                                    if (isLoading || isButtonLoading || isQuickActionLoading) return@onClick
                                                    handleUserMessage(
                                                        question.query,
                                                        isFromQuickAction = true,
                                                        forceReport = question.forceReport
                                                    )
                                                }

                                        ) {
                                            FieldTitleTextNormalSimple(
                                                question.title,
                                                fontSize = 14.px,
                                                fontWeight = 400,
                                                isClickable = !(isLoading && isButtonLoading),
                                                isNotAllowed = isLoading || isButtonLoading
                                            )
                                        }
                                    }
                                }
                            }
                        }
                    }
                }

//                Row(
//                    modifier = Modifier
//                        .fillMaxWidth().height(138.px)
//                        .margin(topBottom = 10.px)
//                        .gap(10.px).overflow(Overflow.Auto)
//                        .flexWrap(FlexWrap.Wrap)
//                )
//                {
//                    quickDashboardActionQuestions.forEach { (category, questions) ->
//                        Column {
//                            Box(
//                                modifier = Modifier
//                                    .backgroundColor(sitePalette.lightGrey.rgb)
//                                    .borderRadius(4.px)
//                                    .cursor(Cursor.Pointer)
//                                    .padding(topBottom = 8.px, leftRight = 8.px)
//                                    .onClick {
//                                        expandedCategory =
//                                            if (expandedCategory == category) null else category
//
//                                    }
//                                    .border(
//                                        1.px,
//                                        style = LineStyle.Solid,
//                                        color = sitePalette.coachDetailsBoxBorder.rgb
//                                    ),
//                                contentAlignment = Alignment.Center
//                            ) {
//                                Row(
//                                    modifier = Modifier.fillMaxSize(),
//                                    verticalAlignment = Alignment.CenterVertically
//                                ) {
//                                    FieldTitleTextNormalSimple(
//                                        category,
//                                        fontSize = 14.px,
//                                        fontWeight = 500,
//                                        isClickable = true
//                                    )
//
//                                    Box(Modifier.weight(1f))
//
//                                    FaPlus(
//                                        size = IconSize.XS,
//                                        modifier = Modifier
//                                            .transition(
//                                                com.varabyte.kobweb.compose.css.Transition.Companion.of(
//                                                    TransitionProperty.All, 300.ms
//                                                )
//                                            )
//                                            .transform {
//                                                rotate(if (expandedCategory == category) 90.deg else 0.deg)
//                                            }
//                                            .margin(left = 10.px)
//                                            .color(sitePalette.primary.rgb)
//                                            .align(Alignment.CenterVertically)
//                                    )
//                                }
//                            }
//
//                            ExpandableContent(visible = expandedCategory == category) {
//                                Column(
//                                    Modifier
//                                        .fillMaxWidth()
//                                        .margin(
//                                            left = 10.px,
//                                            top = 6.px,
//                                            bottom = 4.px
//                                        )
//                                        .gap(6.px)
//                                ) {
//                                    questions.forEach { question ->
//                                        Box(
//                                            Modifier
//                                                .fillMaxWidth()
//                                                .padding(6.px)
//                                                .backgroundColor(Colors.White)
//                                                .borderRadius(4.px)
//                                                .cursor(if (isLoading || isButtonLoading || isQuickActionLoading) Cursor.NotAllowed else Cursor.Pointer)
//                                                .border(
//                                                    1.px,
//                                                    LineStyle.Solid,
//                                                    sitePalette.primary.rgb
//                                                )
//                                                .onClick {
//                                                    if (isLoading || isButtonLoading || isQuickActionLoading) return@onClick
//                                                    handleUserMessage(
//                                                        question.query,
//                                                        isFromQuickAction = true,
//                                                        forceReport = question.forceReport
//                                                    )
//                                                }
//
//                                        ) {
//                                            FieldTitleTextNormalSimple(
//                                                question.title,
//                                                fontSize = 14.px,
//                                                fontWeight = 400,
//                                                isClickable = !(isLoading && isButtonLoading),
//                                                isNotAllowed = isLoading || isButtonLoading
//                                            )
//                                        }
//                                    }
//                                }
//                            }
//                        }
//                    }
//                }

                Box(
                    modifier = Modifier.fillMaxWidth().height(90.px)
                        .position(Position.Relative)
                ) {
                    TextArea(
                        attrs = Modifier.fillMaxWidth()
                            .border(0.px)
                            .backgroundColor(Colors.Transparent)
                            .toAttrs {
                                placeholder(if (overLayOptions && getCoachInfo.payment.checkout.status != Strings.PAID) "" else "Message AssistAI")
                                id(Res.Id.messageAiInput)
                                style {
                                    outline("none")
                                    property("resize", "none")
                                    property("font-family", Constants.IBM_FONT)
                                    property("font-size", "16px")
                                    property("width", "100%")
                                    property("height", "90px")
                                    property("box-sizing", "border-box")
                                    property(
                                        "padding",
                                        "8px 50px 8px 16px"
                                    ) // right padding for button space
                                    property("border-radius", "8px")
                                    property(
                                        "border",
                                        "1px solid ${sitePalette.coachDetailsBoxBorder.rgb}"
                                    )
                                    property(
                                        "background-color",
                                        sitePalette.lightGrey.rgb.toString()
                                    )
                                    property("overflow-y", "auto")
                                }
                                attr("autocomplete", "off")
                                onKeyDown {
                                    if (it.key == "Enter" && !it.shiftKey) {
                                        it.preventDefault()
                                        val inputField =
                                            document.getElementById(Res.Id.messageAiInput) as? HTMLTextAreaElement
                                        val message = inputField?.value.orEmpty()
                                        handleUserMessage(message, isFromQuickAction = false)
                                    }
                                }
                                onInput { event ->
                                    val inputField =
                                        event.nativeEvent.target.unsafeCast<HTMLTextAreaElement>()
                                    userInput = inputField.value
                                }
                            }
                    )
                    Row(
                        modifier = Modifier.fillMaxWidth(),
                        horizontalArrangement = Arrangement.End
                    ) {
                        if (!overLayOptions) {
                            Box(
                                modifier = Modifier
                                    .position(Position.Absolute)
                                    .bottom(11.px)
                                    .right(11.px)
                                    .zIndex(2)
                            ) {
                                val isSendDisabled =
                                    isButtonLoading || userInput.isBlank() || isLoading || isQuickActionLoading
                                if (isButtonLoading) {
                                    Box(
                                        modifier = Modifier.size(40.px)
                                            .borderRadius(100.percent)
                                            .backgroundColor(sitePalette.primary.rgb),
                                        contentAlignment = Alignment.Center
                                    ) {
                                        ProgressIndicator()
                                    }
                                } else {
                                    Image(
                                        src = Res.Images.send_Button,
                                        modifier = Modifier
                                            .size(40.px)
                                            .cursor(if (isSendDisabled) Cursor.NotAllowed else Cursor.Pointer)
                                            .opacity(if (isSendDisabled) 0.5f else 1f)
                                            .onClick {
                                                if (!isSendDisabled) {
                                                    val inputField =
                                                        document.getElementById(Res.Id.messageAiInput) as? HTMLTextAreaElement
                                                    val message = inputField?.value.orEmpty()
                                                    handleUserMessage(
                                                        message,
                                                        isFromQuickAction = false
                                                    )
                                                }
                                            }
                                    )
                                }
                            }
                        }
                    }

                    if (overLayOptions) {
                        Box(
                            modifier = Modifier
                                .fillMaxSize()
                                .position(Position.Absolute)
                                .zIndex(9)
                                .backgroundColor(Colors.Gray.copyf(alpha = 0.2f))
                                .borderRadius(8.px),
                            contentAlignment = Alignment.Center
                        ) {
                            Column(
                                Modifier.fillMaxWidth(),
                                horizontalAlignment = Alignment.CenterHorizontally
                            ) {
                                val message: String
                                val shouldShowSubscribeButton: Boolean

                                if (isIndependentCoach && (!isCoachPaid || !isCoachUnexpired) && questionLimitReached) {
                                    // Independent coach
                                    message =
                                        "Free questions limit reached. Get Subscription to continue using AssistAI"
                                    shouldShowSubscribeButton = true

                                } else if (AppGlobal.userData.role == Strings.ADMIN && (!isClubPaid || !isClubUnexpired) && questionLimitReached) {
                                    // Admin user
                                    message =
                                        "Your subscription has expired. Please renew to continue using AssistAI."
                                    shouldShowSubscribeButton = false

                                } else if (!isIndependentCoach && (!isClubPaid || !isClubUnexpired) && questionLimitReached) {
                                    // Non-independent coach (depends on club)
                                    message =
                                        "Your club subscription has expired. Please contact your club administrator to renew the subscription. Thank you!"
                                    shouldShowSubscribeButton = false

                                } else {
                                    message =
                                        "Note: Coach profile should be complete to use AssistAI"
                                    shouldShowSubscribeButton = false
                                }


                                // Show Subscribe button only if allowed
                                if (shouldShowSubscribeButton) {
                                    CommonButton(
                                        text = "Subscribe",
                                        onCLick = { subscriptionPopup(true) },
                                        width = 80.px,
                                        height = 36.px
                                    )
                                    CustomSpacer(height = 10.px)
                                }

                                FieldTitleTextNormalSimple(
                                    text = message,
                                    fontSize = if (shouldShowSubscribeButton) 12.px else 14.px,
                                    textAlign = TextAlign.Center,
                                    width = 100.percent,
                                    whiteSpace = WhiteSpace.PreWrap,
                                )
                            }
                        }
                    }


                }
            }

        }
    }
}


